import { render, staticRenderFns } from "./clientsTable.vue?vue&type=template&id=00ed4b92&"
import script from "./clientsTable.vue?vue&type=script&lang=js&"
export * from "./clientsTable.vue?vue&type=script&lang=js&"
import style0 from "./clientsTable.vue?vue&type=style&index=0&id=00ed4b92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports